import Breadcrumb from "@/components/breadcrumb/Breadcrumb.vue"
import CountryTag from "@/components/countryTag/CountryTag.vue"
import $ from 'jquery'

export default {
  name: "ProjectDetailHero",
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    geography: {},
    heroMapImage: { type: String, default: "" },
    heroBackgroundImage: { type: String, default: "" }
  },
  computed: { },
  mounted() { },
  created: function () {
    var heroBackgroundImage = this.heroBackgroundImage;
    $(document).ready(function() {
        $(".project-detail-hero").css("background-image", "url('" + require("@/assets/projectDetail/hero/" + heroBackgroundImage))
    });
  },
  components: {
    Breadcrumb,
    CountryTag
  },
  methods: { }

};
